export enum RolesValues {
  Admin = 'ADMIN',
  Supervisor = 'SUPERVISOR',
  Sourcer = 'SOURCER',
  Recruiter = 'RECRUITER',
  ManagerFirstLevel = 'MANAGER_FIRST_LEVEL',
  ManagerSecondLevel = 'MANAGER_SECOND_LEVEL',
  ManagerThirdLevel = 'MANAGER_THIRD_LEVEL',
  ManagerFourthLevel = 'MANAGER_FOURTH_LEVEL',
}

export const RolesNames = {
  [RolesValues.Admin]: 'roles.admin',
  [RolesValues.Supervisor]: 'roles.supervisor',
  [RolesValues.Sourcer]: 'roles.sourcer',
  [RolesValues.Recruiter]: 'roles.recruiter',
  [RolesValues.ManagerFirstLevel]: 'roles.managerFirstLevel',
  [RolesValues.ManagerSecondLevel]: 'roles.managerSecondLevel',
  [RolesValues.ManagerThirdLevel]: 'roles.managerThirdLevel',
  [RolesValues.ManagerFourthLevel]: 'roles.managerFourthLevel',
};

export const ManagerRolesArray = [
  RolesValues.ManagerFirstLevel,
  RolesValues.ManagerSecondLevel,
  RolesValues.ManagerThirdLevel,
  RolesValues.ManagerFourthLevel,
];

// Roles the backend accepts as request executors
export const RequestExecutorRoles = [RolesValues.Recruiter, RolesValues.Admin];

// Roles the backend lets change the priority boost of a request, the others get 403
export const RequestPriorityBoostRoles = [RolesValues.Admin, RolesValues.Supervisor];

export const AllRolesArray = [
  RolesValues.Admin,
  RolesValues.Recruiter,
  RolesValues.Sourcer,
  RolesValues.Supervisor,
  ...ManagerRolesArray,
];

export const ManagerRolesIcons = {
  [RolesValues.ManagerFirstLevel]: 'manager_1_level',
  [RolesValues.ManagerSecondLevel]: 'manager_2_level',
  [RolesValues.ManagerThirdLevel]: 'manager_3_level',
  [RolesValues.ManagerFourthLevel]: 'manager_4_level',
};
